export default function SearchHero() {
  return (
    <section className="w-full border-b border-background-300 bg-background-100">
      <div className="ds-container pb-20 pt-10 text-center md:py-24">
        <div className="mx-auto max-w-4xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-800">
            <i className="ri-flashlight-line" />
            公開資料快速健診
          </span>
          <h1 className="mx-auto mt-5 max-w-3xl text-[1.875rem] font-bold leading-[1.25] tracking-[-0.01em] md:mt-6 md:text-[2.75rem] md:leading-[1.2] md:tracking-[-0.02em]">
            60 秒看懂你的
            <span className="whitespace-nowrap"> Google 商家</span>
            {'，'}
            <br className="hidden sm:block" />
            與附近同業差在哪裡
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-foreground-600 md:mt-6 md:text-lg">
            輸入店家名稱與地區，快速取得公開資料健康度、同業比較與優先改善方向。
          </p>
        </div>
      </div>
    </section>
  );
}